import React from "react";
import "./ClosedDocumentsContainer.less";
import { Col, Row } from "antd";
import ClosedDocuments from "../../components/ClosedDocuments/ClosedDocuments";
import { hasAccess } from "../../components/RolesModule/hasAccess";
import { MENU_BILLING_BILLINGPROCEDURES_WRITE } from "../../lib/const/permissions";
import ErrorPage from "../../components/ErrorPage/ErrorPage";

const ClosedDocumentsContainer = () => {
  

  if (hasAccess(MENU_BILLING_BILLINGPROCEDURES_WRITE)) {
    return (
      <div className="container_height">
        <div className="inner-row">
          <Row justify="space-between" align="middle">
            <Col>
              <h1>Формирование закрывающих документов</h1>
            </Col>
          </Row>
          <ClosedDocuments />
        </div>
      </div>
    );
  }
  return <ErrorPage />;
};

export default ClosedDocumentsContainer;
